import Vue from 'vue'
import Vuex from 'vuex'

import * as auth from './modules/auth.js'
import * as commun from './modules/commun'
import * as tipo from './modules/tipo.store'
import * as entidad from './modules/entidad.store'
import * as retencion from './modules/retencion.store'
import * as cuenta from './modules/cuenta.store'
import * as recaudacion from './modules/recaudacion.store'
import * as year from './modules/year.store'
import * as user from './modules/user.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .3), rgba(0, 0, 0, .3)',
    //barColor: "rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0.5)",
    barImage: 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg',
    //barImage: "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg",
    drawer: null,
    snackbar: {
      visible: false,
      color: 'success',
      text: null,
      timeout: 6000,
      multiline: false,
    },
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    ALERT(state, payload) {
      state.snackbar.text = payload.text
      if (payload.text.length > 50) {
        state.snackbar.multiline = true
      }

      // Si es mas de 50 caracteres definirlo como multilinea
      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline
      }

      // Color para mensajes de error o éxito
      if (payload.color) {
        state.snackbar.color = payload.color
      }

      // Tiempo de duración
      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout
      }
      state.snackbar.visible = true
    },
    CLOSE_ALERT(state) {
      state.snackbar.visible = false
      state.snackbar.multiline = false
      state.snackbar.text = null
    },
  },
  actions: {},
  modules: {
    user,
    auth,
    module,
    commun,
    tipo,
    entidad,
    retencion,
    cuenta,
    recaudacion,
    year,
  },
})
